<template>
  <div>
    <div v-if="loading" class="flex justify-center pt-5">
      <div class="loading loading-ring loading-lg"></div>
    </div>
    <div v-else class="grid grid-cols-2 gap-4 p-4">
      <RoleplayQuestionItem
        v-for="item in list"
        :key="item.id"
        :item="item"
        :mate="mate"
        is-explore
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ApiGetRoleplayQuestionCategoryAll } from "@/apis/roleplay";
import { Mate, RoleplayQuestionCategory } from "@/types/entity";
import { onMounted, ref } from "vue";

const props = defineProps<{
  mate: Mate;
}>();

const list = ref<RoleplayQuestionCategory[]>([]);
const loading = ref(false);
onMounted(() => {
  loading.value = true;
  ApiGetRoleplayQuestionCategoryAll({
    mateId: props.mate.id!,
  }).then((res) => {
    list.value = res.itemzz;
    loading.value = false;
  });
});
</script>
